import { Store } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const StoreIcon = createLucideIcon(Store);
